module.exports = __webpack_public_path__ + "images/free-trial/confetti.d5edd99478515693b894.svg";